import axios, {AxiosInstance, AxiosResponse, AxiosError} from 'axios';

// Get API base URL from environment variable, fallback to relative path for local development
// DO NOT include trailing slash in REACT_APP_API_BASE_URL - endpoints already have leading slashes
const apiBaseURL = process.env.REACT_APP_API_BASE_URL || '/api';

const apiClient: AxiosInstance = axios.create({
  baseURL: apiBaseURL,
  withCredentials: true,
  timeout: 20000, // Timeout in milliseconds
  headers: {
    'Content-Type': 'application/json',
  },
});

function getCookieValueByName({name}: { name: any }) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) {
    return decodeURIComponent(match[2]);
  }
  return null;
}

apiClient.interceptors.request.use(
  (config) => {
    console.log(`🚀 Request ${config.method?.toUpperCase()} to ${config.url}`, config.data);

    const csrfToken = getCookieValueByName({name: 'csrftoken'});
    if (csrfToken) {
      config.headers['X-CSRFToken'] = csrfToken;
      console.log('CSRF token found and added:', csrfToken);
    } else {
      console.warn('No CSRF token found in cookies');
    }
    
    return config;
  },
  (error) => {
    console.error('Error in request interceptor:', error);
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response: AxiosResponse) => {
    console.log(`✅ Response ${response.status} from ${response.config.url}`, {
      status: response.status,
      statusText: response.statusText,
      data: response.data
    });
    return response;
  },
  (error: AxiosError) => {
    console.error(`❌ Error during request to ${error.config?.url}`, {
      message: error.message,
      response: error.response ? {
        status: error.response.status,
        statusText: error.response.statusText,
        data: error.response.data
      } : 'No response'
    });
    return Promise.reject(error);
  }
);

export default apiClient;